import { render, staticRenderFns } from "./sofyre-timeline.vue?vue&type=template&id=6132053c&scoped=true&"
import script from "./sofyre-timeline.vue?vue&type=script&lang=js&"
export * from "./sofyre-timeline.vue?vue&type=script&lang=js&"
import style0 from "./sofyre-timeline.vue?vue&type=style&index=0&id=6132053c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132053c",
  null
  
)

export default component.exports